jQuery(document).ready(function($){

	/* mobile menu trigger */
	$('#mobileTrigger').on('click', function(e){
		var $this = $(this),
		nav = $('header#head #mainMenu');

		if($this.hasClass('opened')){
			$this.removeClass('opened');
			nav.animate({ 'top':'-105vh' }, 500, function(){
				nav.hide();
			});
		}
		else{
			$this.addClass('opened');
			nav.show().animate({ 'top':'0' }, 500);
		}
	})
	

	/* search */
	$('#menu-tools-menu li').eq(2).find('a').click(function(e){
		e.preventDefault();
		e.stopPropagation();
		$('#searchCatalog').slideDown();
	})
	$('#searchCatalog *').click(function(e){
		e.stopPropagation();
	})
	$(window).click(function(){
		$('#searchCatalog').slideUp();
	});
})